import { BorderColor } from "@mui/icons-material";

function navbar(theme, ownerState) {
  const { palette, boxShadows, functions, transitions, breakpoints, borders } =
    theme;
  const { transparentNavbar, absolute, light, darkMode } = ownerState;

  const { dark, white, text, transparent, background } = palette;
  const { navbarBoxShadow } = boxShadows;
  const { rgba, pxToRem } = functions;
  const { borderRadius } = borders;

  return {
    backdropFilter:
      transparentNavbar || absolute ? "none" : `blur(${pxToRem(12)})`,
    backgroundColor: transparentNavbar
      ? `${transparent.main} !important`
      : rgba(darkMode ? background.default : white.main, 0.6),
    boxShadow: transparentNavbar || absolute ? "none" : navbarBoxShadow,

    color: () => {
      if (light) return white.main;
      return darkMode ? white.main : dark.main;
    },
    top: absolute ? 0 : pxToRem(12),
    minHeight: pxToRem(70),
    display: "grid",
    alignItems: "center",
    borderRadius: borderRadius.xl,
    marginBottom: "10px",

    border: darkMode
      ? `1.5px solid ${rgba(white.main, 0.25)}`
      : `1.5px solid ${rgba(dark.main, 0.2)}`,
    borderRadius: "14px",
    transition: transitions.create(
      ["top", "background-color", "box-shadow", "border"],
      {
        easing: transitions.easing.easeInOut,
        duration: transitions.duration.standard,
      },
    ),

    "& > *": {
      transition: transitions.create("all", {
        easing: transitions.easing.easeInOut,
        duration: transitions.duration.standard,
      }),
    },

    "& .MuiToolbar-root": {
      [breakpoints.up("sm")]: {
        minHeight: "auto",
        padding: `${pxToRem(10)} ${pxToRem(20)}`,
      },
    },
  };
}

const navbarContainer = ({ breakpoints }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  gap: 2,
});

const navbarRow = ({ breakpoints }, { isMini }) => ({
  display: "flex",
  alignItems: "center",
  gap: 1.5,
});

const navbarIconButton = ({ typography: { size }, breakpoints }) => ({
  padding: "8px",
  borderRadius: "10px",
  transition: "background-color 0.2s",
  "&:hover": {
    backgroundColor: "rgba(0, 0, 0, 0.04)",
  },
  "& .material-icons, .material-icons-round": {
    fontSize: `1.4rem !important`,
  },
});

const navbarMobileMenu = ({ breakpoints }) => ({
  display: "inline-block",
  lineHeight: 0,
  [breakpoints.up("xl")]: {
    display: "none",
  },
});

export {
  navbar,
  navbarContainer,
  navbarRow,
  navbarIconButton,
  navbarMobileMenu,
};
